module.exports = __webpack_public_path__ + "static/coin-collect-cc30d072603ea1d8649998c126ee935e.mp3";